import { defineComponent as _defineComponent } from 'vue'
import { useTresContext } from '@tresjs/core';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'RendererHelper',
  setup(__props) {

    const { renderer } = useTresContext();
    renderer.value.setPixelRatio(window.devicePixelRatio);
    renderer.value.localClippingEnabled = true;

return () => {}
}

})